import { render, staticRenderFns } from "./DepositChannelSidebar.vue?vue&type=template&id=4df4864c"
import script from "./DepositChannelSidebar.vue?vue&type=script&lang=js"
export * from "./DepositChannelSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports